import Seo from "../components/Seo";
import React, { useState } from "react";
import { api } from "../lib/api";
import { useSettings } from "../context/SettingsContext";
import { Phone, Mail, MapPin, MessageCircle, Send } from "lucide-react";
import { toast } from "sonner";

export default function Contact() {
  const settings = useSettings();
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/inquiries", { ...form, type: "general" }); }
    catch {}
    toast.success("Благодарим! Ще се свържем с вас скоро.");
    setForm({ name: "", email: "", message: "" });
  };

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-16" data-testid="contact-page">
      <Seo title="Контакти" path="/kontakti" description="Свържете се с галерия PenichArt за въпроси относно картини, поръчки и доставка. Художник Силва Пенева, Варна." />
      <div className="text-center mb-12">
        <h1 className="font-serif text-4xl md:text-5xl text-navy">Контакти</h1>
        <p className="text-charcoal/60 mt-3">Нуждаете се от помощ при избора? Пишете ни – ще ви препоръчаме подходящи картини.</p>
      </div>
      <div className="grid lg:grid-cols-2 gap-10">
        <div className="space-y-5">
          {[[Phone, "Телефон", settings?.contact_phone || "+359 88 000 0000"],
            [Mail, "Имейл", settings?.contact_email || "info@penichart.org"],
            [MapPin, "Адрес", settings?.address || "България"]].map(([Icon, t, v]) => (
            <div key={t} className="flex items-center gap-4 bg-white border border-stone p-5">
              <div className="w-11 h-11 border border-gold flex items-center justify-center text-gold"><Icon size={20} /></div>
              <div><p className="text-xs text-charcoal/50">{t}</p><p className="text-navy font-medium">{v}</p></div>
            </div>
          ))}
          <div className="bg-navy text-ivory p-6">
            <div className="flex items-center gap-2 text-gold mb-2"><MessageCircle size={18} /><span className="font-serif text-lg">Нужна ви е помощ при избора?</span></div>
            <p className="text-ivory/75 text-sm">Изпратете снимка на интериора и ще ви предложим подходящи картини за вашето пространство.</p>
          </div>
        </div>
        <form onSubmit={submit} className="bg-white border border-stone p-6 space-y-4">
          <h2 className="font-serif text-2xl text-navy">Изпратете запитване</h2>
          <input required placeholder="Вашето име" value={form.name} onChange={set("name")} className="w-full border border-stone px-4 py-3 outline-none focus:border-gold" data-testid="contact-name" />
          <input required type="email" placeholder="Имейл" value={form.email} onChange={set("email")} className="w-full border border-stone px-4 py-3 outline-none focus:border-gold" data-testid="contact-email" />
          <textarea required placeholder="Вашето съобщение" rows={5} value={form.message} onChange={set("message")} className="w-full border border-stone px-4 py-3 outline-none focus:border-gold" data-testid="contact-message" />
          <button type="submit" className="btn-gold w-full py-3.5 rounded-sm flex items-center justify-center gap-2" data-testid="contact-submit"><Send size={16} /> Изпрати</button>
        </form>
      </div>
    </div>
  );
}
